//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { TelephoneInformationInputItem } from './TelephoneInformationInputItem';
import { AdultInputItem } from './AdultInputItem';
import { FamilyInputItem } from './FamilyInputItem';
import { ChildDetailsInputItem } from './ChildDetailsInputItem';

export class StudentInputItem extends ChildDetailsInputItem {
    FirstName: string | null = null;
    LastName: string | null = null;
    EmailAddress: string | null = null;
    Telephone: TelephoneInformationInputItem | null = null;
    Adult: AdultInputItem | null = null;
    FamilyID?: string | null;
    Family?: FamilyInputItem | null;

    constructor(initializer?: Partial<StudentInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "StudentInputItem";
}
